import { createReducer } from '@reduxjs/toolkit';

import * as htmlCodeActions from './htmlCodeActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: 0,
  sid: 0,
  type: 'html',
  isActive: false,
  isAdded: false,

  content: '',
};

const map = createReducer(initialState, (builder) => {
  builder
    .addCase(htmlCodeActions.htmlCodeUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(htmlCodeActions.htmlCodeUpdateIsAdded, (state, { payload: isAdded }) => ({ ...state, isAdded }))
    .addCase(htmlCodeActions.htmlCodeUpdateIsActive, (state, { payload: isActive }) => ({ ...state, isActive }))

    .addCase(htmlCodeActions.htmlCodeStore, (state, { payload }) => {
      const { id, uid, sid, isActive, isAdded, data } = payload;

      const section = data ?? {};
      const { content } = section;

      return {
        ...state,

        error: null,
        requesting: false,

        id: id ?? 0,
        uid: uid ?? 0,
        sid: sid ?? 0,
        isActive: isActive,
        isAdded: isAdded,

        content: content ?? '',
      };
    })

    .addCase(htmlCodeActions.htmlCodeClear, () => ({ ...initialState }))

    .addCase(htmlCodeActions.htmlCodeUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(htmlCodeActions.htmlCodeUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(htmlCodeActions.htmlCodeUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(htmlCodeActions.htmlCodeUpdateContent, (state, { payload: content }) => ({ ...state, content }));
});

export default map;
